import { TextField, useMediaQuery } from "@material-ui/core";
import React from "react";
import AppTooltip from "./AppTooltip";
import VerifyPasswordInfo from "./VerifyPasswordInfo";
import useStyles from "components/Auth/Register/RegisterStyles";

const VerifyPasswordField = (props) => {
  const classes = useStyles();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const VerifyPassword = !props.verfiyPasswordFieldName;
  return (
    <>
      <AppTooltip title={<VerifyPasswordInfo />} placement="right" arrow>
        <TextField {...props} 
        className={VerifyPassword? classes.validTextField : ""}/>
      </AppTooltip>
      {!matches && <VerifyPasswordInfo />}
    </>
  );
};
export default VerifyPasswordField;
